<template>
    <div class="side-menu">
      <ul>
        <li>
          <router-link :to="'/' + $i18n.locale + '/'">{{ $t('about.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/description'">{{ $t('description.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/team'">{{ $t('team.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/activities'">{{ $t('activities.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/publications'">{{ $t('publications.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/contact'">{{ $t('contact.title') }}</router-link>
        </li>
        <li>
          <router-link :to="'/' + $i18n.locale + '/links'">{{ $t('links.title') }}</router-link>
        </li>
      </ul>
    </div>
</template>

<script>
export default {
name: "LinksMenu"
}
</script>

<style scoped>
.side-menu{
  float: left;
  width: 260px;
  height: 400px;
  margin-bottom: 100px;
}

.side-menu ul{
  list-style: none;
  padding-left: 20px;
  font-size: 110%;
}

.side-menu ul li{
  border-bottom: solid thin black;
  width: 206px;
}

.side-menu ul li a{
  display: block;
  height: 40px;
  width: 206px;
  padding: 6px 0 6px 6px;
  text-decoration: none;
  color: #0f0f0f;
}

.side-menu ul li a:hover{
  background-color: #534b44;
}

.side-menu ul li a:visited{
  background-color: #534b44;
  color: #0f0f0f;
}

.router-link-exact-active {
  background-color: #0f0f0f;
  cursor: default;
}

</style>
